export const habaWishlist = {
  wishlistOverview: {
    title: 'Mes listes',
    addNew: 'Créer une nouvelle liste de souhaits',
    noWishlists: "Vous n'avez pas de listes",
  },
  wishlistCreate: {
    placeholder: 'Saisir le nom de la liste de suivi',
    button: 'Enregistrer une nouvelle liste de souhaits',
    successMessage: 'Liste de suivi créée',
    errorLengthMin: 'Le nom doit être plus long que trois lettres.',
    errorLengthMax: 'Le nom doit être inférieur à 100 lettres.',
    errorExitsAlready: 'Le nom existe déjà.',
    emptiedListSuccessMessage: 'Vos produits ont été ajoutés au panier',
    listCreated: 'Liste de suivi créée',
    addNew: 'Créer une liste de souhaits',
    title: 'Créer une liste',
  },
  wishlistEdit: {
    edit: 'Modifier la liste',
    rename: 'Renommer la liste',
    delete: 'Supprimer la liste',
    successMessage: 'Liste éditée',
    questionDelete:
      "Voulez-vous vraiment supprimer la liste de souhaits et tous les produits qu'elle contient?",
  },
  wishlistList: {
    noItems: 'Aucun élément disponible dans cette liste',
    allToBasket: 'Tous les articles dans le panier',
    deleteWishlist: 'Supprimer ce mémo',
    removedSuccessMessage: 'Liste supprimée',
    itemRemovedSuccessMessage: 'Liste mise à jour',
    deletedList: 'Votre liste de souhaits a été supprimée',
  },
  wishlistMove: {
    title: 'Déplacer le produit',
    subtitle: 'Sélectionnez une liste de souhaits:',
    successMessage: 'Votre produit a été reporté',
    warningCartsMessage: "Vous n'avez qu'une seule liste",
  },
  wishlistAdd: {
    addToWishlist: 'Ajouter à la liste de souhaits',
    addToWishlistTitle: 'Ajouter à la liste de souhaits',
    addToCartSuccess: 'Votre produit a été ajouté au panier',
    warningSelectWishlist: "Vous devez d'abord sélectionner une liste",
    title: 'Veuillez sélectionner une liste',
    noListsCreatedMessage:
      "Tu n'as pas encore créé de liste de souhaits. <br> Clique ci-dessous pour créer une nouvelle liste de favoris.",
    createWishlistAltText: 'ou créer une nouvelle liste',
    addedToWishlist: 'Ajouté à la liste',
    addToWishlistLink: 'Ajouter à la liste de souhaits',
    addedToWishlistNoticed: 'Remarqué',
    removeItemFromWishlist: 'Das Produkt wurde von der Merkliste entfernt.',
    addInWishlist: 'Zur Wunschliste hinzufügen',
    removeFromWishlist: 'Von der Wunschliste entfernen',
  },
  wishlistRemove: {
    main: {
      title: "Qu'est-ce que tu veux faire?",
      addToWishlist: 'AJOUTER À UNE AUTRE LISTE',
    },
    secondary: {
      title: "De quelle liste l'article doit- il être supprimé?",
    },
    removeFromWishlist: 'SUPPRIMER DE LA LISTE DE SUIVI',
  },
};
